import { IFeatureParams, IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '../models/features.enum';
import { Injectable } from '@angular/core';

@Injectable()
export class HoldQtyByLoadSizeFeature implements IFlagFeature {
  name = Features.HOLD_QTY_BY_LOAD_SIZE;

  public isEnabled(container: IToggleContainer, params: IFeatureParams): boolean {
    return container[this.name].isEnabled();
  }
}
